import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoginSitecoreContent } from 'libs/content-service/def/login-content';
import { Observable } from 'rxjs';
import { BaseDataService } from '../../libs/data-service/base-data-service';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { Errors } from './def/login-content';
import { BaseContentService } from './base-content-service';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class LoginContentService extends BaseContentService<
  LoginSitecoreContent
> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService, LoginContentService.staticlogin);
  }

  get data$(): Observable<LoginSitecoreContent> {
    if (!this.loaded) {
      return this.getLoginData();
    }

    return of(this.data);
  }

  getLoginData(): Observable<LoginSitecoreContent> {
    const url = `${this.serviceBaseUrl}login`;
    return this.get<LoginSitecoreContent>(url).pipe(
      map(data => {
        this.data = this.loginMapper(data);
        this.loaded = true;
        return this.data;
      }),
      catchError(this.handleError)
    );
  }

  private loginMapper(data: LoginSitecoreContent): LoginSitecoreContent {
    if (!data) return;

    return data;
  }

  private static staticlogin: LoginSitecoreContent = {
    pageName: 'login',
    data: [
      {
        heading: '',
        title: '',
        description: '',
        text: '',
        image: null,
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 1,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 2,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 3,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 4,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 5,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 6,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 7,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 8,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    media: [
      {
        heading: '',
        description: '',
        navigation: {
          Anchor: '',
          Class: '',
          Text: '',
          Query: '',
          Title: '',
          Url: '',
          Target: '',
          TargetId: '00000000-0000-0000-0000-000000000000',
          Type: 2,
          Style: ''
        },
        image: null,
        displayItems: []
      }
    ],
    products: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: 'ef124a0c-6a66-4dfd-bfd5-b66045908ee1',
              Type: 6,
              Style: ''
            },
            orderId: 1,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '5a1d5ab4-99ad-446b-ad1f-bf511b9bc5b3',
              Type: 6,
              Style: ''
            },
            orderId: 2,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '83e00c37-dfd8-498d-bee0-983f2746cf62',
              Type: 6,
              Style: ''
            },
            orderId: 3,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '9e2b0d86-9b03-458e-9544-6dfc7a496f5c',
              Type: 6,
              Style: ''
            },
            orderId: 4,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '9ee8b3a4-de07-45e9-9baa-cb045fe94f8f',
              Type: 6,
              Style: ''
            },
            orderId: 5,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '4f3e0f9f-7178-44d6-a3a0-5a6c1f3007e3',
              Type: 6,
              Style: ''
            },
            orderId: 6,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '080d3ce6-bc6c-4b23-9c84-4dfe0447c4b8',
              Type: 6,
              Style: ''
            },
            orderId: 7,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    brochures: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: 'a6df5b68-2af2-4c20-8c64-2906bd01487c',
              Type: 6,
              Style: ''
            },
            orderId: 1,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '5a1d5ab4-99ad-446b-ad1f-bf511b9bc5b3',
              Type: 6,
              Style: ''
            },
            orderId: 2,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '9e2b0d86-9b03-458e-9544-6dfc7a496f5c',
              Type: 6,
              Style: ''
            },
            orderId: 3,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '83e00c37-dfd8-498d-bee0-983f2746cf62',
              Type: 6,
              Style: ''
            },
            orderId: 4,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: 'ef124a0c-6a66-4dfd-bfd5-b66045908ee1',
              Type: 6,
              Style: ''
            },
            orderId: 5,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '9ee8b3a4-de07-45e9-9baa-cb045fe94f8f',
              Type: 6,
              Style: ''
            },
            orderId: 6,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '4f3e0f9f-7178-44d6-a3a0-5a6c1f3007e3',
              Type: 6,
              Style: ''
            },
            orderId: 7,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '080d3ce6-bc6c-4b23-9c84-4dfe0447c4b8',
              Type: 6,
              Style: ''
            },
            orderId: 8,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: 'eff9f2e7-f8eb-405c-be46-de08aa1abe6c',
              Type: 6,
              Style: ''
            },
            orderId: 9,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '8b5c085b-1802-4c54-9127-8b1083aebc7c',
              Type: 6,
              Style: ''
            },
            orderId: 10,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    messages: [
      {
        heading: '',
        description: '',
        image: null,
        displayItems: []
      }
    ]
  };

  oktaConfiguration() {
    return {
      'primaryauth.title': 'Login to Your Account:',
      'primaryauth.submit': 'Login',
      'error.username.required': 'Please enter an Email Address or User ID',
      goback: 'Back to Sign In',

      'enroll.choices.description':
        'Tokio Marine HCC requires multifactor authentication to add an additional layer of security when signing into your account. Select an option to start authentication.',
      'enroll.totp.enrollViaSms.title': 'SMS sent!',
      'enroll.totp.enrollViaSms.msg': 'View the SMS on your mobile device.',
      'mfa.sent': 'code sent',
      'mfa.sendCode': 'Send code',
      'mfa.resendCode': 're-send code',
      'mfa.backToFactors': 'Back to authentication options',

      'factor.sms': 'Text Message to Your Phone',
      'factor.sms.description':
        'Enter a single-use code sent to your mobile phone.',
      'factor.securityQuestion': 'Security Question',
      'factor.securityQuestion.description':
        'Use the answer to a security question to authenticate.'
    };
  }

  oktaErrorModal() {
    return {
      data: {
        para: '',
        phone: '',
        email: '',
        showFooterBtn: true,
        footerBtnLabel: '',
        footerBtnCallback: null
      },
      modalSetting: {
        title: '',
        hideHeader: false,
        hideFooter: true,
        hideHeaderX: false, // header X button;
        hideSave: true,
        closeOnOutsideClick: true
      }
    };
  }

  errorOktaMsg(): Errors {
    const userName = JSON.parse(sessionStorage.getItem('userName'));
    return {
      status4: `To protect your identity, we are enhancing the security of ArtisanEdge up a notch by updating your username with your current email address in the system, ${userName}. Please make a note of this change and login again. ${userName}`,
      status5: `To protect your identity, we are enhancing the security of ArtisanEdge up a notch by updating your username with your current email address in the system, ${userName}. , but we found your email address is already assoicated with another account in the system, please contact our underwriters, (855) 733-9500. ${userName}`,
      signinFailed: `Sign in failed! Please check your username and password.`
    };
  }
}
